import { css, DefaultTheme, ThemedStyledProps } from 'styled-components';
import { TRANSITION_TIMEOUT_MILLIS } from './constants';

export const createSwitchTransition = (
  property: string | string[] = 'all',
) => css<ThemedStyledProps<unknown, DefaultTheme>>`
  transition: ${({ theme }) =>
    theme.transitions.create(
      property,
      `${TRANSITION_TIMEOUT_MILLIS}ms`,
      'ease',
    )};
`;
